import $ from 'jquery';
import { pushLoginHeaderEvent } from './booking/tagging';

export default function() {
  $('#loginBtn').on('click', () => {
    pushLoginHeaderEvent();
  });
}
